// The site manual PDFs ship with the portal (public/). Corporate and
// individual customers each get their own edition.
const SITE_MANUAL_URLS = {
    corporate: `${process.env.PUBLIC_URL}/PortalSite2026_Manual_Corporate.pdf`,
    individual: `${process.env.PUBLIC_URL}/PortalSite2026_Manual_Individual.pdf`
};

export const getSiteManualUrl = (profile) => (profile?.is_business_account ? SITE_MANUAL_URLS.corporate : SITE_MANUAL_URLS.individual);

// The sidebar banner is for personal (個人) customers; 法人 customers keep the
// floating bear. `false`, not falsy: unknown while the profile is loading.
export const isPersonalAccount = (profile) => profile?.is_business_account === false;
export const isBusinessAccount = (profile) => profile?.is_business_account === true;
